const getLastYearYM = () => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - 1);
  return Intl.DateTimeFormat(undefined, {
    year: "numeric",
    month: "2-digit",
  })
    .formatToParts(date)
    .filter(({ type, value }) => type !== "literal")
    .map(({ type, value }) => value)
    .join("");
};

export const DateUtil = { getLastYearYM };
